class AutoHide
{
    constructor()
    {
        this.hideElements = document.querySelectorAll('.js-autohide');
        this.delayedTimer = 3;
        this.hideTimer = 10;
        this.element = null;
        this.timeout = null;
    }

    init()
    {
        this.hideElements.forEach(element =>
        {
            // elements with class .js-show-once are stored in session storage
            if (sessionStorage.getItem('shownOnce') == null
				|| !sessionStorage.getItem('shownOnce').includes(element.id))
            {
                this.element = element;

                if (element.classList.contains('js-delayed'))
                {
                    this.initDelay(this.element);
                }

                this.timeout = this.initTimeout(
                    this.element,
                    element.classList.contains('js-delayed') ? this.hideTimer + this.delayedTimer : this.hideTimer
                );

                this.initEvents(element);
            }
        });
    }

    initDelay(element)
    {
        setTimeout(() =>
        {
            this.showElement(element);
        }, this.delayedTimer * 1000);
    }

    initTimeout(element, timer)
    {
        return setTimeout(() =>
        {
            this.hideElement(element);

            if (element.classList.contains('js-show-once'))
            {
                this.setShownOnce(element);
            }
        }, timer * 1000);
    }

    initEvents(element)
    {
        this.element.addEventListener('mouseenter', () =>
        {
            clearTimeout(this.timeout);
        });
        this.element.addEventListener('mouseleave', () =>
        {
            this.timeout = this.initTimeout(this.element, this.hideTimer);
        });
        this.element.querySelector('.close').addEventListener('click', () =>
        {
            this.setShownOnce(element);
        });
    }

    setShownOnce(element)
    {
        sessionStorage.setItem('shownOnce', sessionStorage.getItem('shownOnce') == null
            ? element.id
            : !sessionStorage.getItem('shownOnce').includes(element.id)
                ? sessionStorage.getItem('shownOnce') + ',' + element.id
                : sessionStorage.getItem('shownOnce'));
    }

    showElement(element)
    {
        element.classList.remove('hidden');
    }

    hideElement(element)
    {
        element.classList.add('hidden');
    }
}

let autoHide = new AutoHide();

autoHide.init();
